import {ArtfactKind} from '@mrp-brasil/nick-data-commons';
import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import * as https from 'https';
import * as http from 'http';
import {from, Observable, Observer, of} from 'rxjs';
import fs, {promises as fsPromises} from 'fs';
import {v4 as uuid} from 'uuid';
import heicConvert from 'heic-convert'
import {catchError, concatMap, map} from "rxjs/operators";

@HookClass('file')
export class FileHook extends BaseHook {

    @Hook('b6b067e6-f21d-4aa9-ac8a-a2f2367d10a2')
    public base64ToBuffer(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {

        const outputArtifact = new NickProcessArtfact();

        outputArtifact.kind = ArtfactKind.ANY;
        outputArtifact.object = Buffer.from(inputArtifact.object.data
            .replace(new RegExp(/^data:image\/(png|gif|jpeg);base64,/, 'g'), ''), 'base64');
        return of(outputArtifact);
    }

    @Hook('aa565db8-00bc-4b90-8e5c-60599c80e17d')
    public bufferToBase64(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const outputArtifact = new NickProcessArtfact();

        const buffer = inputArtifact.object.data as Buffer;
        const mimeType = inputArtifact.object.mimeType || 'image/jpeg'; // default to JPEG if not provided

        const base64String = buffer.toString('base64');
        const dataUrl = `data:${mimeType};base64,${base64String}`;

        outputArtifact.kind = ArtfactKind.ANY;
        outputArtifact.object = dataUrl;
        return of(outputArtifact);
    }

    @Hook('9d5463f5-549b-4c9e-b7f0-792d24930643')
    public downloadFile(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const outputArtifact = new NickProcessArtfact();
        const protocol = inputArtifact.object.url.startsWith('https://') ? https : http;

        return new Observable<any>((observer: Observer<any>) => {
            protocol.get(inputArtifact.object.url, {rejectUnauthorized: false}, (response: any) => {
                const chunks: any[] = [];

                response.on('data', (chunk: any) => {
                    chunks.push(chunk);
                });

                response.on('end', () => {
                    outputArtifact.object = Buffer.concat(chunks);
                    observer.next(outputArtifact);
                    observer.complete();
                });
            });
        });
    }

    @Hook('2992f378-7dcf-4c00-8785-ad47da339736')
    public convertHeicToJpeg(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {

        const heicFile = inputArtifact.object.data;

        if (!heicFile || !(heicFile instanceof Buffer)) {
            return new Observable((observer) => {
                observer.error(new Error('inputArtifact.object.data must be a Buffer'));
            });
        }

        // 🔹 Cria um Observable a partir da Promise do heicConvert
        return from(
            heicConvert({
                buffer: heicFile,
                format: 'JPEG',
                quality: 0.9
            })
        ).pipe(
            // 🔹 Transforma o buffer JPEG em NickProcessArtifact
            map((jpegBuffer: Buffer) => {
                const outputArtifact = new NickProcessArtfact();
                outputArtifact.kind = inputArtifact.kind;
                outputArtifact.object = {
                    buffer: jpegBuffer,
                    originalFilename: inputArtifact.object.originalFilename?.replace(/\.heic$/i, '.jpg'),
                    mimetype: 'image/jpeg',
                    size: jpegBuffer.length
                };
                return outputArtifact;
            }),

            // 🔹 Tratamento reativo de erro
            catchError((error) => {
                console.error('Erro na conversão HEIC → JPEG:', error);
                // `throw error` repropaga o erro para quem estiver inscrito
                throw error;
            })
        );
    }

    @Hook('4b71ef79-2c4e-451a-b664-5719aaa9018c')
    public jsonToBuffer(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
      const outputArtifact = new NickProcessArtfact();
      outputArtifact.kind = ArtfactKind.ANY;
      outputArtifact.object = Buffer.from(JSON.stringify(inputArtifact.object.data));
      return of(outputArtifact);
    }

    @Hook('3c71fae3-d871-49c1-abe2-80a7d6f104d0')
    public stringToBuffer(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;
        if (inputArtifact.object.config?.output == 'file') {
            if (inputArtifact.object.config.fileName)
                this.context.response.attachment(inputArtifact.object.config.fileName);
            if (inputArtifact.object.config.contentType)
                this.context.response.type(inputArtifact.object.config.contentType);
            outputArtifact.object = new NickProcessArtfact();
            outputArtifact.object.kind = 10;
            const filePath = `/tmp/${uuid()}`;
            fs.writeFileSync(filePath, Buffer.from(inputArtifact.object.data));
            outputArtifact.object.object = fs.readFileSync(filePath);
        } else
            outputArtifact.object = Buffer.from(inputArtifact.object.data);
        return of(outputArtifact);
    }
}
